import { IAttrValue } from "@multiweb/types/contracts";
import { CultureInfo } from "../../../../Global/Dom/CultureInfo";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ItemTemplate } from "../Templates/ItemTemplate";
import { Column } from "./Column";

export class TimeSpanColumn extends Column {
    //#region Fields
    //#endregion

    //#region Methods

    /**
     * Zformátování jsonu do formátu timeSpanu podle display formatu.
     * @param data Data v jsonu.
     */
    public override async formatValue(data: IAttrValue): Promise<string> {
        let duration = AttrValueReader.read(data);

        if (duration == null)
            return "";

        let resultString = "";

        if (duration < 0) {
            resultString = "-";
            duration *= -1;
        }

        // https://docs.microsoft.com/en-us/dotnet/standard/base-types/standard-timespan-format-strings
        // Defaultní formát odpovídá displayFormat == 'c' || 't' || 'T'
        const isDisplayFormat_g = this.displayFormat == "g";
        const isDisplayFormat_G = this.displayFormat == "G";

        const secondsToTicks = 10000000;
        const minutesToTicks = 600000000; // 60 * secondsToTicks
        const hoursToTicks = 36000000000; // 60 * minutesToTicks
        const daysToTicks = 864000000000; // 24 * hoursToTicks

        const days = Math.floor(duration / daysToTicks);
        const hours = Math.floor((duration - (days * daysToTicks)) / hoursToTicks);
        const minutes = Math.floor((duration - (days * daysToTicks) - (hours * hoursToTicks)) / minutesToTicks);
        const seconds = (duration - (days * daysToTicks) - (hours * hoursToTicks) - (minutes * minutesToTicks)) / secondsToTicks;

        if ((isDisplayFormat_g && days != 0) || isDisplayFormat_G) {
            resultString += days + ":";
        } else if (days != 0) {
            resultString += days + ".";
        }

        if (isDisplayFormat_g) {
            resultString += hours + ":";
        } else {
            resultString += this._pad(hours, 2) + ":";
        }

        resultString += this._pad(minutes, 2) + ":";

        if (seconds < 10)
            resultString += "0";

        if (isDisplayFormat_g) {
            resultString += seconds.toLocaleString(CultureInfo.getCultureInfo().name, { maximumFractionDigits: 7 });
        } else if (isDisplayFormat_G || seconds % 1 != 0) {
            resultString += seconds.toLocaleString(CultureInfo.getCultureInfo().name, { minimumFractionDigits: 7, maximumFractionDigits: 7 });
        } else {
            resultString += seconds;
        }

        return resultString;
    }

    /**
     * Metoda pro doplnění vodících nul a převod na string.
     * @param num Číslo, které je potřeba upravit.
     * @param size Požadovaný počet znaků výsledního stringového řetězce.
     */
    private _pad(num: number, size: number): string {
        let strNum = num.toString();

        while (strNum.length < size)
            strNum = "0" + num;

        return strNum;
    }
    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new ItemTemplate();
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-timespancolumn", TimeSpanColumn);
